import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';

const SQUARE_COMMON_PROPS = {
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
};

const HALF_ROW_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_1200,
    height: FoundationsCobrandedRegularTheme.size_250,
  },
  IMAGE_PROPS = {
    shapeVariant: 'CIRCLE',
    variant: 'CIRCLE_DEFAULT',
    width: FoundationsCobrandedRegularTheme.size_900,
    height: FoundationsCobrandedRegularTheme.size_900,
  },
  LINE_SEPARATOR_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: '100%',
    height: FoundationsCobrandedRegularTheme.size_50,
  },
  NUMBER_STEPS_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_750,
    height: FoundationsCobrandedRegularTheme.size_250,
  },
  QUARTER_ROW_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_950,
    height: FoundationsCobrandedRegularTheme.size_250,
  },
  ROW_PROPS = {
    ...SQUARE_COMMON_PROPS,
    height: FoundationsCobrandedRegularTheme.spacing_300,
    width: 'auto',
  },
  BOX_PROPS = {
    ...SQUARE_COMMON_PROPS,
    height: FoundationsCobrandedRegularTheme.size_650,
    width: 'auto',
  },
  SKELETON_PROPS = {
    ...SQUARE_COMMON_PROPS,
    height: '100%',
    width: '100%',
  },
  SUBTITLE_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_675,
    height: FoundationsCobrandedRegularTheme.spacing_350,
  },
  TITLE_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_1083,
    height: FoundationsCobrandedRegularTheme.spacing_350,
  },
  TITLE_STEP_PROPS = {
    ...SQUARE_COMMON_PROPS,
    width: FoundationsCobrandedRegularTheme.size_1110,
    height: FoundationsCobrandedRegularTheme.size_300,
  };

export {
  BOX_PROPS,
  HALF_ROW_PROPS,
  IMAGE_PROPS,
  LINE_SEPARATOR_PROPS,
  NUMBER_STEPS_PROPS,
  QUARTER_ROW_PROPS,
  ROW_PROPS,
  SKELETON_PROPS,
  SUBTITLE_PROPS,
  TITLE_PROPS,
  TITLE_STEP_PROPS,
};
